import { useEffect, useMemo, useState } from 'react'
import BlurHashImage from '@components/BlurHashImage'
import { BLUR_HASH_MAP } from '@constants/BlurHashItems'
import { imageLoadCache } from '@utils/image-load-cache'
import './UtilityFloorplanDetail.css'

const clamp = (value, min, max) => Math.max(min, Math.min(max, value))

const toPercentNumber = (value) => {
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace('%', ''))
    return Number.isFinite(parsed) ? clamp(parsed, 0, 100) : 0
  }
  if (!Number.isFinite(value)) return 0
  if (value <= 1 && value >= 0) {
    return clamp(value * 100, 0, 100)
  }
  return clamp(value, 0, 100)
}

const Icon360 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 33 18"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M3.563 8.45c-5.92 3.29 10.028 5.29 13.62 5.257V11.7l2.986 3.022-2.986 3.027v-1.88c-7.22.277-24.215-4.43-13.993-8.337.096.305.213.594.346.863l.027.054Zm25.3-6.208c0-.704.125-1.198.375-1.479.25-.28.631-.42 1.145-.42.245 0 .45.032.607.091a1.1 1.1 0 0 1 .387.24c.1.097.178.203.236.31.06.108.104.235.139.38.07.276.101.565.101.867 0 .672-.112 1.165-.338 1.476-.224.31-.61.466-1.161.466-.306 0-.557-.051-.746-.148-.19-.1-.346-.246-.466-.437a1.659 1.659 0 0 1-.205-.559 3.839 3.839 0 0 1-.075-.787Zm-21.81.588-2.398-.432c.2-.771.58-1.365 1.148-1.778C6.368.207 7.169 0 8.205 0c1.19 0 2.049.224 2.581.674.53.45.794 1.017.794 1.697 0 .4-.11.76-.322 1.082-.216.324-.538.607-.973.85.352.089.624.191.807.31.304.189.538.44.706.747.168.31.253.677.253 1.106 0 .54-.138 1.055-.415 1.552-.28.493-.68.874-1.201 1.14-.522.268-1.21.4-2.062.4-.828 0-1.483-.1-1.96-.297a2.906 2.906 0 0 1-1.183-.868c-.309-.38-.546-.861-.71-1.438l2.537-.343c.102.518.253.88.464 1.082.208.2.474.302.799.302.338 0 .62-.127.847-.378.226-.25.338-.588.338-1.009 0-.429-.11-.76-.325-.995-.216-.235-.511-.354-.884-.354-.197 0-.472.049-.818.152l.13-1.838c.14.022.248.033.326.033.327 0 .602-.108.82-.321.218-.213.33-.464.33-.758 0-.284-.082-.508-.247-.672-.166-.167-.395-.251-.68-.251-.298 0-.538.092-.724.272-.19.178-.314.497-.38.953Zm12.964-.6-2.524.314c-.067-.356-.176-.605-.33-.75a.815.815 0 0 0-.576-.219c-.41 0-.73.208-.956.629-.165.305-.29.95-.368 1.94.304-.313.616-.543.932-.691.32-.148.69-.224 1.108-.224.815 0 1.502.294 2.064.882.562.591.845 1.338.845 2.242a3.35 3.35 0 0 1-.426 1.673c-.285.504-.68.887-1.183 1.146-.506.26-1.137.389-1.899.389-.913 0-1.646-.157-2.197-.475-.551-.316-.994-.817-1.324-1.508-.33-.69-.495-1.605-.495-2.746 0-1.668.346-2.89 1.041-3.667C14.42.388 15.38 0 16.611 0c.727 0 1.3.083 1.72.253.421.17.773.421 1.05.745.28.33.492.74.636 1.233ZM15.35 6.354c0 .502.125.893.372 1.176.25.284.554.427.916.427.333 0 .613-.13.837-.386.224-.256.335-.64.335-1.15 0-.52-.117-.92-.349-1.192a1.1 1.1 0 0 0-.868-.41c-.351 0-.65.132-.89.4-.236.264-.354.641-.354 1.135Zm5.403-1.613c0-1.756.312-2.987.938-3.688C22.313.35 23.267 0 24.542 0c.616 0 1.119.078 1.513.23.394.153.717.352.964.598.25.245.448.504.589.774.144.273.258.588.346.95a8.97 8.97 0 0 1 .256 2.158c0 1.678-.28 2.903-.842 3.68-.56.777-1.523 1.165-2.895 1.165-.767 0-1.387-.124-1.862-.372a3.025 3.025 0 0 1-1.163-1.093c-.219-.34-.392-.803-.515-1.394a9.825 9.825 0 0 1-.18-1.956Zm2.512.005c0 1.176.101 1.98.309 2.412.205.432.503.645.895.645.258 0 .48-.092.668-.273.19-.183.328-.474.416-.868.09-.397.133-1.012.133-1.848 0-1.228-.101-2.05-.309-2.477-.205-.42-.514-.634-.924-.634-.421 0-.722.216-.911.645-.184.434-.277 1.233-.277 2.398Zm6.605-2.5c0 .471.04.792.123.965.082.173.202.26.36.26a.367.367 0 0 0 .268-.111c.075-.073.13-.19.168-.349.035-.159.053-.404.053-.739 0-.49-.04-.823-.122-.992-.083-.17-.205-.254-.37-.254-.168 0-.29.086-.365.259-.078.173-.115.494-.115.96Zm-.756 5.91c2.812 1.449 2.141 3.505-2.84 4.754-1.411.353-3.006.674-4.756.806v1.633c1.947-.138 3.758-.591 5.343-.98 7.489-1.837 7.228-5.117 2.492-6.968a6.102 6.102 0 0 1-.24.755Z"
    />
  </svg>
)

function UtilityFloorplanDetail({
  isOpen,
  onClose,
  activeScene,
  points = [],
  onPointClick,
  planTang1,
  planTang2,
}) {
  const [activeFloor, setActiveFloor] = useState(1)
  const [openFloorMenu, setOpenFloorMenu] = useState(false)
  const [hoveredNumber, setHoveredNumber] = useState(null)
  const [planLoaded, setPlanLoaded] = useState(() => imageLoadCache.has(activeFloor === 1 ? planTang1 : planTang2))

  // Normalize coordinates
  const normalizedPoints = useMemo(() => {
    return points.map((p) => ({
      ...p,
      xPercent: toPercentNumber(p.x ?? p.left ?? 0),
      yPercent: toPercentNumber(p.y ?? p.top ?? 0),
    }))
  }, [points])

  // Find active point
  const activePoint = useMemo(() => {
    return normalizedPoints.find((p) => p.scene === activeScene)
  }, [normalizedPoints, activeScene])

  // State for adjusting activeFloor when activePoint changes
  const [prevActivePoint, setPrevActivePoint] = useState(null)
  if (activePoint !== prevActivePoint) {
    setPrevActivePoint(activePoint)
    if (activePoint && activePoint.floor) {
      setActiveFloor(activePoint.floor)
    }
  }

  // Filter points for active floor
  const visiblePoints = useMemo(() => {
    return normalizedPoints.filter((p) => p.floor === activeFloor)
  }, [normalizedPoints, activeFloor])

  // Get unique points by number for the list panel on the right
  const uniqueVisiblePoints = useMemo(() => {
    const seen = new Set()
    return visiblePoints.filter((p) => {
      if (p.number === undefined || p.number === null) return true
      if (seen.has(p.number)) return false
      seen.add(p.number)
      return true
    })
  }, [visiblePoints])

  const currentPlanImage = activeFloor === 1 ? planTang1 : planTang2

  // Sync blur state when floor plan image changes — skip blur if already cached
  useEffect(() => { setPlanLoaded(imageLoadCache.has(currentPlanImage)) }, [currentPlanImage])

  if (!isOpen) return null

  return (
    <div className="utility-floorplan-detail" role="dialog" aria-modal="true">
      {/* Background overlay */}
      <div className="utility-floorplan-detail__overlay" onClick={onClose} />

      {/* Modal Wrapper Box */}
      <div className="utility-floorplan-detail__wrapper">
        <div className="utility-floorplan-detail__inner">
          {/* Close button */}
          <button
            type="button"
            onClick={onClose}
            className="utility-floorplan-detail__close-btn"
            aria-label="Đóng"
          >
            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          {/* Split Layout Row */}
          <div className="utility-floorplan-detail__row">
            {/* Left: Big Map Viewport */}
            <div className="utility-floorplan-detail__map-side">
              {/* Selector tầng dạng dropdown nằm phía bên trên ảnh */}
              <div className="utility-floorplan-detail__floor-selector">
                <button
                  type="button"
                  onClick={() => setOpenFloorMenu(!openFloorMenu)}
                  className="utility-floorplan-detail__title-trigger"
                  aria-label="Chọn tầng hiển thị"
                >
                  <span>{`TẦNG ${activeFloor}`}</span>
                  <svg
                    className={`utility-floorplan-detail__chevron ${openFloorMenu ? 'rotate-180' : ''}`}
                    viewBox="0 0 10 6"
                    width="10"
                    height="6"
                    fill="currentColor"
                  >
                    <polygon points="0,0 10,0 5,6" />
                  </svg>
                </button>

                {openFloorMenu && (
                  <div className="utility-floorplan-detail__dropdown">
                    <button
                      type="button"
                      onClick={() => {
                        if (activeFloor !== 1) {
                          setActiveFloor(1)
                          const targetPoint = normalizedPoints.find((p) => p.floor === 1 && p.scene)
                          if (targetPoint && onPointClick) {
                            onPointClick(targetPoint)
                          }
                        }
                        setOpenFloorMenu(false)
                      }}
                      className={`utility-floorplan-detail__dropdown-item${activeFloor === 1 ? ' utility-floorplan-detail__dropdown-item--active' : ''}`}
                    >
                      Tầng 1
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (activeFloor !== 2) {
                          setActiveFloor(2)
                          const targetPoint = normalizedPoints.find((p) => p.floor === 2 && p.scene)
                          if (targetPoint && onPointClick) {
                            onPointClick(targetPoint)
                          }
                        }
                        setOpenFloorMenu(false)
                      }}
                      className={`utility-floorplan-detail__dropdown-item${activeFloor === 2 ? ' utility-floorplan-detail__dropdown-item--active' : ''}`}
                    >
                      Tầng 2
                    </button>
                  </div>
                )}
              </div>

              <div className="utility-floorplan-detail__map-card">
                <div className="utility-floorplan-detail__map-container">
                  <BlurHashImage hash={BLUR_HASH_MAP.plan} fadeOut={planLoaded} />
                  {currentPlanImage && (
                    <img
                      src={currentPlanImage}
                      alt={`Chi tiết sơ đồ tầng ${activeFloor}`}
                      className="utility-floorplan-detail__bg-img"
                      onLoad={() => { imageLoadCache.add(currentPlanImage); setPlanLoaded(true) }}
                    />
                  )}

                  {/* Numbered Hotspot buttons on the map */}
                  {visiblePoints.map((point) => {
                    const isActive = point.scene && point.scene === activeScene
                    const isHovered = hoveredNumber !== null && hoveredNumber === point.number
                    return (
                      <button
                        key={point.id || point.scene}
                        type="button"
                        onClick={() => {
                          if (point.scene) {
                            onPointClick?.(point)
                            onClose()
                          }
                        }}
                        onMouseEnter={() => setHoveredNumber(point.number)}
                        onMouseLeave={() => setHoveredNumber(null)}
                        className={`utility-floorplan-detail__hotspot${isActive ? ' utility-floorplan-detail__hotspot--active' : ''} ${isHovered ? 'utility-floorplan-detail__hotspot--hovered' : ''}`}
                        style={{
                          left: `${point.xPercent}%`,
                          top: `${point.yPercent}%`
                        }}
                      >
                        <div className="utility-floorplan-detail__hotspot-circle">
                          {point.number}
                        </div>
                      </button>
                    )
                  })}
                </div>
              </div>
            </div>

            {/* Right: Info Panel */}
            <div className="utility-floorplan-detail__info-side">
              <div className="utility-floorplan-detail__info-spacer" style={{ opacity: 0, pointerEvents: 'none', userSelect: 'none' }}>
                <button type="button" className="utility-floorplan-detail__title-trigger">
                  <span>TẦNG</span>
                </button>
              </div>
              <div className="utility-floorplan-detail__info-panel-container">
                <div className="utility-floorplan-detail__info-panel">
                  {/* Items List */}
                  <div className="utility-floorplan-detail__info-list-wrapper">
                    <div className="utility-floorplan-detail__info-list">
                      {uniqueVisiblePoints.map((item) => {
                        const isActive = item.scene && item.scene === activeScene
                        const isHovered = hoveredNumber !== null && hoveredNumber === item.number
                        return (
                          <div
                            key={item.id}
                            className={`utility-floorplan-detail__info-item${isActive ? ' utility-floorplan-detail__info-item--active' : ''} ${isHovered ? 'utility-floorplan-detail__info-item--hovered' : ''}`}
                            onMouseEnter={() => setHoveredNumber(item.number)}
                            onMouseLeave={() => setHoveredNumber(null)}
                            onClick={() => {
                              if (item.scene) {
                                onPointClick?.(item)
                                onClose()
                              }
                            }}
                          >
                            {/* Number Badge */}
                            <div className="utility-floorplan-detail__item-number">
                              {item.number}
                            </div>

                            {/* Item Label */}
                            <span className="utility-floorplan-detail__item-label">
                              {item.label}
                            </span>

                            {/* 360 Icon */}
                            {item.scene && (
                              <div className="utility-floorplan-detail__item-360">
                                <Icon360 />
                              </div>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UtilityFloorplanDetail
